export default __webpack_public_path__ + "static/fb-1db92574968d27eb7b941f4b19dcf842.png";